module.exports = __webpack_public_path__ + "img/EMT-OPSCC_PMID37704757.3c23ac5b.png";